import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import {
  ConsoleLogger,
  DefaultMessagingSession,
  LogLevel,
  MessagingSessionConfiguration,
} from "amazon-chime-sdk-js";
import * as AWS from "aws-sdk/global";
import Chime from "aws-sdk/clients/chime";
import { Component } from "vue-property-decorator";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { v4 } from "uuid";
import NewMessage from "@/resources/mixins/notifications/newMessage";
import { CONFIG, ConfigInterface } from "@/resources/constants/system";
import { TYPES_MESSAGES } from "@/resources/constants/messages";
import { MEETING_TYPE } from "../../constants/meeting";
@Component({})
export default class Chat extends mixins(UserValidator, NewMessage) {
  async createMessaging(): Promise<void> {
    AWS.config.update({
      region: "us-east-1",
      credentials: {
        accessKeyId: process.env.VUE_APP_CHIME_KEY_ID,
        secretAccessKey: process.env.VUE_APP_CHIME_SECRET_ID,
      },
    });
    const logger = new ConsoleLogger("CHIME_CHAT_LOGS", LogLevel.ERROR);

    const sessionId = v4(); /* The sessionId */
    const chime = new Chime({ region: "us-east-1" });
    const user = this.$store.getters["UserStore/getSpaceUser"];
    const url = this.$store.getters["ChatStore/getEndPointUrl"];
    const messagingConfig = new MessagingSessionConfiguration(
      user.chimeUserArn,
      sessionId,
      url,
      chime
    );
    const messagingSession = new DefaultMessagingSession(
      messagingConfig,
      logger
    );
    await this.startMessagingObserver(messagingSession);
    await this.$store.dispatch(
      "ChatStore/setMessagingSessionAction",
      messagingSession
    );
  }
  async startMessagingObserver(
    messagingSession: DefaultMessagingSession
  ): Promise<void> {
    const observer = {
      messagingSessionDidStart: () => {
        if (process.env.NODE_ENV !== "production")
          console.log("CHIME_CHAT Session started");
      },
      messagingSessionDidStartConnecting: (reconnecting) => {
        if (reconnecting) {
          if (process.env.NODE_ENV !== "production")
            console.log("CHIME_CHAT Start reconnecting");
        } else {
          if (process.env.NODE_ENV !== "production")
            console.log("CHIME_CHAT Start connecting");
        }
      },
      messagingSessionDidStop: (event) => {
        if (process.env.NODE_ENV !== "production")
          console.log(`CHIME_CHAT Closed: ${event.code} ${event.reason}`);
      },
      messagingSessionDidReceiveMessage: (message) => {
        if (message.type !== "CREATE_CHANNEL_MESSAGE") return;
        if (!message.payload) return;

        const userChat = this.$store.getters["ChatStore/getUserChat"];
        const space = this.$store.getters["SpaceStore/getSpace"];
        const localUser = this.$store.getters["UserStore/getSpaceUser"];
        const payload = JSON.parse(message.payload);
        const { Metadata } = payload;
        const {
          type,
          fromSuperSpaceUserId,
          messageType,
          roomId,
          spaceId,
          isMultiWebinarMessage,
        } = JSON.parse(Metadata);
        const openChat = this.$store.getters["SidebarStore/getOpenChat"];
        const chatType = this.$store.getters["ChatStore/getChatType"];
        const minimizeChat = this.$store.getters["ChatStore/getMinimizeChat"];
        const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
        const roomMeetingId = this.$store.getters["MeetingStore/getRoomId"];
        if (openChat && chatType === type) {
          if (
            minimizeChat ||
            (userChat &&
              userChat.id !== fromSuperSpaceUserId &&
              fromSuperSpaceUserId !== localUser.superSpaceUser.id)
          ) {
            if (
              (meetingType === MEETING_TYPE.WEBINAR &&
                !isMultiWebinarMessage &&
                type === CHAT_TYPE.ROOM &&
                roomId !== roomMeetingId) ||
              (!isMultiWebinarMessage &&
                type === CHAT_TYPE.ROOM &&
                roomId !== roomMeetingId)
            )
              return;
            if (type === "SPACE" && spaceId !== space.id) return;
            if (messageType === TYPES_MESSAGES.REACTION) return;
            this.addNewUnSeenMessage(type, payload);
            return;
          }
          /* const activeMenu = this.$store.getters["SidebarStore/getActiveMenu"];
          if (activeMenu !== -1) {
            this.playSound();
          } */
          if (
            (meetingType === MEETING_TYPE.WEBINAR &&
              !isMultiWebinarMessage &&
              type === CHAT_TYPE.ROOM &&
              roomId !== roomMeetingId) ||
            (!isMultiWebinarMessage &&
              type === CHAT_TYPE.ROOM &&
              roomId !== roomMeetingId)
          )
            return;

          if (type === "SPACE" && spaceId !== space.id) return;
          this.$store.dispatch("ChatStore/addNewMessageAction", payload);
          setTimeout(() => {
            const chatContent = document.getElementById("chat-content");
            if (chatContent.scrollHeight < chatContent.scrollTop + 1000)
              chatContent.scrollTop = chatContent.scrollHeight * 1000;
          }, 50);
        } else {
          const roomMeetingId = this.$store.getters["MeetingStore/getRoomId"];
          if (
            type === CHAT_TYPE.ROOM &&
            !isMultiWebinarMessage &&
            roomId !== roomMeetingId
          )
            return;
          if (type === "SPACE" && spaceId !== space.id) return;
          if (messageType === TYPES_MESSAGES.REACTION) return;
          if (fromSuperSpaceUserId === localUser.superSpaceUser.id) return;
          this.addNewUnSeenMessage(type, payload);
        }
      },
    };

    messagingSession.addObserver(observer);
    await messagingSession.start();
  }

  async addNewUnSeenMessage(chatType: string, payload: any): Promise<void> {
    const { Metadata } = payload;
    const { fromSuperSpaceUserId, messageType } = JSON.parse(Metadata);

    const localUser = this.$store.getters["UserStore/getSpaceUser"];
    if (
      fromSuperSpaceUserId === localUser.id ||
      payload.Content.includes("/*>/") ||
      payload.Content.includes("/*g/") ||
      messageType === TYPES_MESSAGES.PAPER_PLANE ||
      messageType === TYPES_MESSAGES.ANNOUNCEMENT ||
      messageType === TYPES_MESSAGES.REACTION
    ) {
      return;
    }
    await this.$store.dispatch("ChatStore/addUnSeenMessageAction", {
      id: CHAT_TYPE.ONE_TO_ONE ? fromSuperSpaceUserId : null,
      type: chatType,
      payload,
    });
    this.playSound();
    const MetadataJson = JSON.parse(Metadata);
    const user = {
      superSpaceUser: {
        id: MetadataJson.fromSuperSpaceUserId,
        user: { name: MetadataJson.fromSuperSpaceUserName },
      },
    };
    /*this.onNewMessage(
      payload.Sender.Name,
      chatType === CHAT_TYPE.ONE_TO_ONE ? user : null,
      chatType
    );*/
  }
  playSound() {
    const audio = new Audio(require("@/assets/audio/alert.mp3"));
    const config: ConfigInterface = this.$store.getters["UserStore/getConfig"];
    if (!config.notification.silenceNotification) {
      audio.volume = 0.2;
      audio.muted = false;
      audio.play().then();
    }
  }
}
